import { Modal, Skeleton } from "antd";
import React, { useState } from "react";
import { useIntl } from "react-intl";
import { useFetchStage } from "../../entities/api";
import AddAndEditStageForm from "./AddAndEditStageForm";

const AddAndEditStageModal = ({
  handleCloseModal,
  openModal,
  stageCode = null,
  handleSendRequest,
  okButtonLoading,
}) => {
  const { formatMessage } = useIntl();
  const [formRef, setFormRef] = useState(null);
  const { data: stage } = useFetchStage(stageCode);

  const handleSetFormRef = (form) => setFormRef(form);

  return (
    <Modal
      width={550}
      open={openModal}
      closable={true}
      destroyOnClose={true}
      onCancel={handleCloseModal}
      title={formatMessage({
        id: !stageCode ? "stage.add" : "stage.update",
      })}
      okText={formatMessage({
        id: !stageCode ? "add" : "update",
      })}
      onOk={() => handleSendRequest(formRef)}
      okButtonProps={{ loading: okButtonLoading }}
    >
      {!stageCode ? (
        <AddAndEditStageForm handleSetFormRef={handleSetFormRef} />
      ) : stage ? (
        <AddAndEditStageForm stage={stage} handleSetFormRef={handleSetFormRef} />
      ) : (
        <Skeleton />
      )}
    </Modal>
  );
};

export default AddAndEditStageModal;
